import { bn } from "../../../../date-fns/locale/bn.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    bn
  }
};